import { render } from "./Home.vue?vue&type=template&id=2bebc6f7"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "/home/suportedeltasolucoescom/webapps/suportedeltasolucoescom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__